<section class="sign-off-employee" data-testid="data-terminal-sign-off-employee">
    <p>
        {{ 'DC.SIGN_OFF_DIALOG.EMPLOYEES.DESCRIPTION' | translate }}
    </p>
    <div class="sign-off-employee__list-of-workstations">
        @for (signOff of signOffMachines; track identify($index, signOff)) {
            @if (shouldDisplayCard(signOff)) {
                <data-terminal-sign-off-employees-card
                    class="hdmui-m-3"
                    [machine]="signOff.machine"
                    [operatorId]="userId"
                    (stateCardChange)="onDataChange($event)"
                    [attr.data-testid]="'data-terminal-sign-off-employees-card-' + signOff.machine.machineId"
                ></data-terminal-sign-off-employees-card>
            }
        }
    </div>
</section>
